module.exports = __webpack_public_path__ + "static/Parking.7cbd54f9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/rooms/icons/Parking.svg
// module id = 95
// module chunks = 7134270256118 260247219796250